export default __webpack_public_path__ + "static/media/blackPanther.adcc209a.png";